module.exports = __webpack_public_path__ + "img/trending-thumb.3ba29aa4.jpg";